import * as React from 'react';
import { motion } from 'motion/react';
import { getVariants, useAnimateIconContext, IconWrapper } from './AnimateIcon';

const animations = {
  default: {
    path1: {
      initial: { opacity: 1 },
      animate: {
        opacity: [0, 1],
        pathLength: [0, 1],
        transition: { ease: 'easeInOut', duration: 0.4, delay: 0 },
      },
    },
    path2: {
      initial: { opacity: 1 },
      animate: {
        opacity: [0, 1],
        pathLength: [0, 1],
        transition: { ease: 'easeInOut', duration: 0.4, delay: 0.3 },
      },
    },
    path3: {
      initial: { opacity: 1 },
      animate: {
        opacity: [0, 1],
        pathLength: [0, 1],
        transition: { ease: 'easeInOut', duration: 0.4, delay: 0.6 },
      },
    },
    path4: {},
  },
};

function IconComponent({ size, ...props }) {
  const { controls } = useAnimateIconContext();
  const variants = getVariants(animations);

  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <motion.path d="M8 17V13" variants={variants.path1} initial="initial" animate={controls} />
      <motion.path d="M13 17V5" variants={variants.path2} initial="initial" animate={controls} />
      <motion.path d="M18 17V9" variants={variants.path3} initial="initial" animate={controls} />
      <motion.path d="M3 3v16a2 2 0 0 0 2 2h16" variants={variants.path4} initial="initial" animate={controls} />
    </motion.svg>
  );
}

function ChartColumn(props) {
  return <IconWrapper icon={IconComponent} {...props} />;
}

export { animations, ChartColumn, ChartColumn as ChartColumnIcon };
